'use strict';

var reactRouterDom = require('react-router-dom');

function useSearchParams() {
    const [searchParamsRR, setSearchParams] = reactRouterDom.useSearchParams();
    const searchParams = Object.assign(searchParamsRR, {
        getOptional(key) {
            var _a;
            return (_a = searchParamsRR.get(key)) !== null && _a !== void 0 ? _a : undefined;
        },
    });
    return [searchParams, setSearchParams];
}

Object.defineProperty(exports, "Link", {
    enumerable: true,
    get: function () { return reactRouterDom.Link; }
});
Object.defineProperty(exports, "MemoryRouter", {
    enumerable: true,
    get: function () { return reactRouterDom.MemoryRouter; }
});
Object.defineProperty(exports, "NavLink", {
    enumerable: true,
    get: function () { return reactRouterDom.NavLink; }
});
Object.defineProperty(exports, "Outlet", {
    enumerable: true,
    get: function () { return reactRouterDom.Outlet; }
});
Object.defineProperty(exports, "Route", {
    enumerable: true,
    get: function () { return reactRouterDom.Route; }
});
Object.defineProperty(exports, "RouterProvider", {
    enumerable: true,
    get: function () { return reactRouterDom.RouterProvider; }
});
Object.defineProperty(exports, "Routes", {
    enumerable: true,
    get: function () { return reactRouterDom.Routes; }
});
Object.defineProperty(exports, "createBrowserRouter", {
    enumerable: true,
    get: function () { return reactRouterDom.createBrowserRouter; }
});
Object.defineProperty(exports, "useBlocker", {
    enumerable: true,
    get: function () { return reactRouterDom.useBlocker; }
});
Object.defineProperty(exports, "useLocation", {
    enumerable: true,
    get: function () { return reactRouterDom.useLocation; }
});
Object.defineProperty(exports, "useNavigate", {
    enumerable: true,
    get: function () { return reactRouterDom.useNavigate; }
});
Object.defineProperty(exports, "useParams", {
    enumerable: true,
    get: function () { return reactRouterDom.useParams; }
});
exports.useSearchParams = useSearchParams;
